import { IPitchFilter, IPitchValue } from "../abstraction/IPitchFilter";


const PITCH_MA_WINDOW_SIZE = 5;

const MAX_NUMBER_OF_EMPTY_VALUE_ALLOWED_IN_MA = 0;


export class PitchFilter1 implements IPitchFilter {


    processSample(value: IPitchValue): IPitchValue {

        this.addRaw(value);

        return this.processLast();
    }


    protected addRaw(value: IPitchValue) {

        if (!value.pitch) {
            this.rawData.push(value);
            return;
        }

        let size = this.rawData.length - 2;
        if (size < 0) {
            this.rawData.push(value);
            return;
        }

        let count = 1;
        let sum = value.pitch;

        while (size < this.rawData.length - 1) {
            if (this.rawData[size].pitch) {
                sum += this.rawData[size].pitch;
                count++;
            }
            size++;
        }

        this.rawData.push({
            ...value,
            pitch: sum / count
        });
    }

    protected processLast() : IPitchValue {

        let lastIndex = this.rawData.length - 1;
        const lastValue = this.rawData[lastIndex];

        if (this.rawData.length < PITCH_MA_WINDOW_SIZE)
            return { ...lastValue, pitch: undefined }; 

        let i = 0;
        let count = 0;
        let result = 0;

        while (i < PITCH_MA_WINDOW_SIZE) {

            const value = this.rawData[lastIndex - i].pitch;

            if (value) {
                result += value;
                count++;
            }
            i++;
        }

        if (i - count > MAX_NUMBER_OF_EMPTY_VALUE_ALLOWED_IN_MA)
            return { ...lastValue, pitch: undefined }
        
        return {
            ...lastValue,
            pitch: result / count
        }
    }

    rawData: IPitchValue[] = [];
}